import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { useTranslation } from "react-i18next";

function AboutCard() {
  const { t } = useTranslation();

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {t("about.cardIntroBefore")}{" "}
            <span className="purple">Adrian Xavier</span>
            {t("about.cardIntroMiddle")}{" "}
            <span className="purple">{t("about.cardRole")}</span>{" "}
            {t("about.cardFrom")}{" "}
            <span className="purple">{t("about.cardCountry")}</span>.
            <br />
            <br />
            {t("about.cardCompanyBefore")}{" "}
            <a
              href="https://www.ignitecorp.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="purple ignite-link"
            >
              Ignite Corporation
            </a>
            {t("about.cardCompanyAfter")}
            <br />
            <br />
            {t("about.cardActivities")}
          </p>

          <ul>
            {t("about.activities", { returnObjects: true }).map((activity) => (
              <li className="about-activity" key={activity}>
                <ImPointRight /> {activity}
              </li>
            ))}
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
